export default __webpack_public_path__ + "static/favicon-1f0d5dfb6c2a1a67e574d9498b761da7.ico";